const BACKURL = process.env.REACT_APP_BACK_URL;
// const BACKURL = 'http://localhost:4000';

const SOCKETURL = process.env.REACT_APP_SOCKET_URL;
// const SOCKETURL = 'http://localhost:4040';

const GLOBALURL = SOCKETURL;

module.exports = {
  BACKURL,
  SOCKETURL,
  GLOBALURL,
};
